import styled from 'styled-components';
import { Text } from '@comicrelief/component-library';

const Container = styled.div`
  margin: 1rem 2rem;
  padding: 0 1.2rem;
`;

const PartnerText = styled(Text)`
  text-align: center;
`;

const ProviderLogosWrapper = styled.div`
  margin-top: 30px;
  display: flex;
  justify-content: center;
  gap: 15px;
  @media (min-width: 400px) {
    gap: 45px;
  }
`;

const Logo = styled.div`
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;

const BraintreeWrapper = styled(Logo)`
  margin-top: 3px;
  width: 110px;
`;

const StripeWrapper = styled(Logo)`
  width: 50px;
`;

const GoCardlessWrapper = styled(Logo)`
  margin-bottom: 2px;
  width: 102px;
`;

const DirectDebitLogosWrapper = styled(ProviderLogosWrapper)`
  margin: 0 0 1.5rem;
  gap: 3rem;
`;

const DirectDebitLogoWrapper = styled(Logo)`
  width: 80px;
`;

export function DirectDebitLogos() {
  return (
    <Container>
      <DirectDebitLogosWrapper>
        <DirectDebitLogoWrapper>
          <img src="/assets/images/direct-debit-logo.svg" alt="Direct Debit Logo" />
        </DirectDebitLogoWrapper>
        <DirectDebitLogoWrapper>
          <img src="/assets/images/provider-logo-gocardless.svg" alt="GoCardless Logo" />
        </DirectDebitLogoWrapper>
      </DirectDebitLogosWrapper>
    </Container>
  );
}

export function ProviderLogos() {
  return (
    <Container>
      <PartnerText tag="p" family="Montserrat" size="xs" color="black">
        We&apos;ve partnered with the following payment providers to process your donation securely.
      </PartnerText>

      <ProviderLogosWrapper>
        <BraintreeWrapper>
          <img src="/assets/images/provider-logo-braintree.svg" alt="Braintree Logo" />
        </BraintreeWrapper>
        <StripeWrapper>
          <img src="/assets/images/provider-logo-stripe.svg" alt="Stripe Logo" />
        </StripeWrapper>
        <GoCardlessWrapper>
          <img src="/assets/images/provider-logo-gocardless.svg" alt="GoCardless Logo" />
        </GoCardlessWrapper>
      </ProviderLogosWrapper>
    </Container>
  );
}
